import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);
const DupeIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);
const ArrowIcon = () => (
  <svg width="8" height="8" viewBox="0 0 24 24" fill="white">
    <path d="M8 5v14l11-7z"/>
  </svg>
);

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const to = data.to || "";
  const subject = data.subject || "";

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 14,
      border: "1.5px solid rgba(16, 185, 129, 0.25)",
      boxShadow: "0 4px 16px rgba(16, 185, 129, 0.12), 0 1px 4px rgba(0,0,0,0.04)",
      minWidth: 220,
      maxWidth: 260,
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
      position: "relative",
      overflow: "visible",
    }}>
      <div style={{ position: "absolute", top: -32, right: 0, display: "flex", gap: 6 }}>
        <button style={{ width: 26, height: 26, borderRadius: "50%", background: "#10b981", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Duplicar" onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}>
          <DupeIcon />
        </button>
        <button style={{ width: 26, height: 26, borderRadius: "50%", background: "#ef4444", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Excluir" onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}>
          <TrashIcon />
        </button>
      </div>

      <Handle type="target" position="left"
        style={{ background: "#10b981", width: 14, height: 14, left: -8, top: 28, border: "2px solid #fff", boxShadow: "0 2px 8px rgba(16,185,129,0.35)" }}
        isConnectable={isConnectable}><ArrowIcon /></Handle>

      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "12px 14px 10px", borderBottom: "1px solid rgba(16,185,129,0.1)" }}>
        <div style={{ width: 28, height: 28, borderRadius: 8, background: "linear-gradient(135deg, #10b981 0%, #059669 100%)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 4px 10px rgba(16,185,129,0.3)" }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="white"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
        </div>
        <span style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", letterSpacing: "-0.01em" }}>Enviar Email</span>
      </div>

      <div style={{ padding: "10px 12px 12px" }}>
        {(to || subject) ? (
          <div style={{ background: "#f0fdf4", border: "1px solid rgba(16,185,129,0.15)", borderRadius: 10, padding: "8px 10px", fontSize: 12, color: "#374151", lineHeight: 1.55 }}>
            {to && <div style={{ marginBottom: 2 }}><span style={{ color: "#6b7280", fontSize: 11 }}>Para: </span>{to.length > 30 ? to.slice(0,30) + "…" : to}</div>}
            {subject && <div><span style={{ color: "#6b7280", fontSize: 11 }}>Assunto: </span>{subject.length > 28 ? subject.slice(0,28) + "…" : subject}</div>}
          </div>
        ) : (
          <div style={{ background: "#f0fdf4", border: "1px dashed rgba(16,185,129,0.3)", borderRadius: 10, padding: "10px", fontSize: 11.5, color: "#94a3b8", fontStyle: "italic", textAlign: "center" }}>
            Clique duplo para configurar...
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 8, gap: 6, paddingRight: 4 }}>
          <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>Próxima etapa</span>
        </div>
      </div>

      <Handle type="source" position="right" id="a"
        style={{ background: "#059669", width: 14, height: 14, right: -8, bottom: 18, top: "auto", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(5,150,105,0.35)" }}
        isConnectable={isConnectable}><ArrowIcon /></Handle>
    </div>
  );
});
